// src/apis/quotation.ts
import { IReceivedQuotationListResult, ISalesQuotation } from "../models/Quotation"
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

const commentHttp = new HttpRequest()
commentHttp.errorHandler = (_statusCode, error) => {
  throw error
}

export interface IReceivedQuotationListParams {
  offset: { page: number; limit: number }
  filter?: { status?: string; query?: string }
}

export const list = async (
  params: IReceivedQuotationListParams,
): Promise<IReceivedQuotationListResult> => {
  return httpRequest.get("/pricing/received-quotation", params as any)
}

export const get = async (id: string): Promise<ISalesQuotation> => {
  return httpRequest.get(`/pricing/received-quotation/${id}`)
}

export const accept = async (id: string): Promise<ISalesQuotation> => {
  return httpRequest.post(`/pricing/received-quotation/${id}/accept`)
}

export const reject = async (
  id: string,
  data: { reason: string },
): Promise<ISalesQuotation> => {
  return httpRequest.post(`/pricing/received-quotation/${id}/reject`, data)
}

export const saveComments = async (
  id: string,
  comments: { itemId: string; comment: string }[],
): Promise<ISalesQuotation> => {
  return commentHttp.post(`/pricing/received-quotation/${id}/comments`, { comments })
}

export const pdfUrl = (id: string): string => {
  return `/pricing/received-quotation/${id}/pdf`
}
